/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { CliplisterFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { CliplisterFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const cliplisterDataMock: CliplisterFragmentFragment = {
  orderNumber: '96692022',
  cliplister: {
    url: 'fancy/cliplister/url',
  },
};

export function getCliplisterFragmentedData(data?: CliplisterFragmentFragment) {
  return makeFragmentData(data || cliplisterDataMock, CliplisterFragmentFragmentDoc);
}
